<template>
    <DiffViewer
        v-if="dialogRef"
        class="diff-viewer"
        :from="dialogRef.data.diffFrom"
        :to="dialogRef.data.diffTo"
        :name="dialogRef.data.artefact.name"
        :mimetype="dialogRef.data.artefact.mimetype"
        :trim="false"
        viewType="draft"
        :style="{ 'max-height': '60vh' }"
    />
    <div :class="DialogStyle.classes.footer">
        <Button
            severity="danger"
            label="Discard draft"
            class="p-button-secondary"
            @click="
                () => {
                    emit('discard');
                    dialogRef!.close();
                }
            "
        />

        <Button
            label="Restore"
            :autofocus="true"
            class="p-button-secondary"
            @click="
                () => {
                    emit('restore');
                    dialogRef!.close();
                }
            "
        />
    </div>
</template>

<script lang="ts" setup>
import DialogStyle from "primevue/dialog/style";
import { Ref, inject } from "vue";
import DiffViewer from "@/components/Diff/DiffViewer.vue";
import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
const emit = defineEmits(["restore", "discard"]);

const dialogRef = inject<Ref<DynamicDialogInstance> | undefined>("dialogRef");
</script>

<style lang="scss">
.diff-viewer {
    width: 100%;
    height: 80vh;
}
</style>
